import React from 'react'
import ReactDOM from 'react-dom/client'

import App from './App'
import {mocksEnabled, startMocks} from './mocks/browser'
import './styles/index.css'

async function boot(): Promise<void> {
    if (mocksEnabled) {
        await startMocks()
    } else {
        console.info('[main] mocks disabled via VITE_ENABLE_MOCKS=false — expecting a real focalboard server')
    }

    ReactDOM.createRoot(document.getElementById('root')!).render(
        <React.StrictMode>
            <App/>
        </React.StrictMode>,
    )
}

boot().catch((error) => {
    console.error('[main] failed to boot', error)
    document.getElementById('root')!.innerHTML = '<p style="padding:24px;font-family:sans-serif">启动失败，请查看浏览器控制台。</p>'
})
